// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_cssW-926fd9":"774fd78a1e21916fe4de","lib_index_js":"e1684daab4071df2a519","style_index_js":"ffba65ae5eb5066fb4d7"}[chunkId] + ".js";
};